<!-- 确认认证接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "20190423090000",
            },
            responseCode: {
                "data": {
                    "agreement": {},
                    "businessAccount": {
                        "bankBranchName": "2322",
                        "bankCardImg": "https://xxx/openydt/files/images/pm-97-fbc-60d191a181c3c8527bacc934.jpg?s=342",
                        "bankNumber": "1232223212211",
                        "bankType": "xxx",
                        "bankUserName": "32231",
                        "businessImg": "https://xxx/openydt/files/images/pm-97-cp-60d191a181c3c8527bacc937.jpg?s=5232",
                        "businessLicense": "https://xxx/openydt/files/images/pm-97-bl-60d191a181c3c8527bacc931.jpg?s=dab10295",
                        "businessLicenseCode": "345157362534",
                        "businessName": "1h",
                        "businessScope": "23g",
                        "businessTimeFrom": "20200826",
                        "businessTimeTo": "20200826",
                        "certificateHolderName": "123432232",
                        "customTel": "12312234542",
                        "idCardBack": "https://xxx/openydt/files/images/pm-97-bpi-60d191a181c3c8527bacc933.jpg?s=61a912bb",
                        "idCardFront": "https://xxx/openydt/files/images/pm-97-fpi-60d191a181c3c8527bacc932.jpg?s=7735d054",
                        "idCardNumber": "12344321232",
                        "idCardValidTimeFrom": "20200505",
                        "idCardValidTimeTo": "20200827",
                        "name": "sdfs",
                        "openAccountImg": "https://xxx/openydt/files/images/pm-97-aopp-60d191a181c3c8527bacc935.jpg?s=2c06133c",
                        "phone": "15232323233",
                        "stopCarImg": "https://xxx/openydt/files/images/pm-97-ppf-60d191a181c3c8527bacc936.jpg?s=f8b89120"
                    },
                    "email": "124534513@qq.com",
                    "parkCode": "2KKN6335",
                    "parkName": "测试车场",
                    "phone": "15232323233",
                    "registerAddress": "sasd",
                    "settlementType": 1,
                    "wechatPayStatus": 3
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,授权商需要把有清算需求的停车场进件到清算平台时，可以通过本接口获取进件信息（目前仅支持一点停清算平台）",
                t_url: this.commonUrls.test+"getParkMerchantDetail",
                p_url: this.commonUrls.prod+"getParkMerchantDetail",
                precondition: "无",
                fitSystem: "云停车场,VEMS传统车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'parkCode', info4: '停车场编码' },
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'wechatPayStatus', info2: '是', info3: 'Integer', info4: '微信支付开通状态：0:未开通 1：审核中 2：开通成功 3：开通失败' },
                        { info1: 'settlementType', info2: '是', info3: 'String', info4: '结算账户类型:1对公账户，2私人账户' },
                        { info1: 'registerAddress', info2: '是', info3: 'String', info4: '注册地址' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '联系人手机号码' },
                        { info1: 'email', info2: '是', info3: 'String', info4: '联系人常用邮箱' },
                        { info1: 'personalAccount', info2: '否', info3: 'String', info4: '私人账户信息，当结算类型为2时' },
                        { info1: 'businessAccount', info2: '否', info3: 'String', info4: '对公账户信息，当结算类型为1时' },
                        { info1: 'agreement', info2: '否', info3: 'String', info4: '服务协议信息' },
                        ]
                },{
                    titleName: 'businessAccount',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'businessName', info2: '是', info3: 'String', info4: '企业名称' },
                        { info1: 'businessLicenseCode', info2: '是', info3: 'String', info4: '营业执照注册号' },
                        { info1: 'businessScope', info2: '是', info3: 'String', info4: '经营范围' },
                        { info1: 'businessTimeFrom', info2: '是', info3: 'String', info4: '营业执照成立日期：yyyyMMdd' },
                        { info1: 'businessTimeTo', info2: '是', info3: 'String', info4: '营业执照结束日期：yyyyMMdd，长期时为汉字‘长期’' },
                        { info1: 'businessLicense', info2: '是', info3: 'String', info4: '营业执照照片' },
                        { info1: 'certificateHolderName', info2: '是', info3: 'String', info4: '法人姓名' },
                        { info1: 'idCardNumber', info2: '是', info3: 'String', info4: '法人身份证号码' },
                        { info1: 'idCardFront', info2: '是', info3: 'String', info4: '法人身份证正面照片' },
                        { info1: 'idCardBack', info2: '是', info3: 'String', info4: '法人身份证反面照片' },
                        { info1: 'idCardValidTimeFrom', info2: '是', info3: 'String', info4: '法人身份证生效日期：yyyyMMdd' },
                        { info1: 'idCardValidTimeTo', info2: '是', info3: 'String', info4: '法人身份证失效日期：yyyyMMdd，长期时为汉字‘长期’' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '联系人姓名' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '联系人手机号码' },
                        { info1: 'bankType', info2: '是', info3: 'String', info4: '银行名称' },
                        { info1: 'bankBranchName', info2: '是', info3: 'String', info4: '支行名称' },
                        { info1: 'bankUserName', info2: '是', info3: 'String', info4: '开户名称' },
                        { info1: 'bankNumber', info2: '是', info3: 'String', info4: '银行账号' },
                        { info1: 'bankCardImg', info2: '是', info3: 'String', info4: '银行卡正面照片' },
                        { info1: 'bankPhone', info2: '是', info3: 'String', info4: '银行卡预留手机号码' },
                        { info1: 'openAccountImg', info2: '是', info3: 'String', info4: '开户许可证照片' },
                        { info1: 'stopCarImg', info2: '是', info3: 'String', info4: '停车场门面照片' },
                        { info1: 'businessImg', info2: '是', info3: 'String', info4: '收银台照片' },
                        { info1: 'customTel', info2: '是', info3: 'String', info4: '客服电话' },
                        ]
                },{
                    titleName: 'personalAccount',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'storeName', info2: '是', info3: 'String', info4: '门店名称' },
                        { info1: 'certificateHolderName', info2: '是', info3: 'String', info4: '法人姓名' },
                        { info1: 'idCardNumber', info2: '是', info3: 'String', info4: '法人身份证号码' },
                        { info1: 'idCardFront', info2: '是', info3: 'String', info4: '法人身份证正面照片' },
                        { info1: 'idCardBack', info2: '是', info3: 'String', info4: '法人身份证反面照片' },
                        { info1: 'idCardValidTimeFrom', info2: '是', info3: 'String', info4: '法人身份证生效日期：yyyyMMdd' },
                        { info1: 'idCardValidTimeTo', info2: '是', info3: 'String', info4: '法人身份证失效日期：yyyyMMdd，长期时为汉字‘长期’' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '联系人姓名' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '联系人手机号码' },
                        { info1: 'bankType', info2: '是', info3: 'String', info4: '银行名称' },
                        { info1: 'bankBranchName', info2: '是', info3: 'String', info4: '支行名称' },
                        { info1: 'bankUserName', info2: '是', info3: 'String', info4: '开户名称' },
                        { info1: 'bankNumber', info2: '是', info3: 'String', info4: '银行账号' },
                        { info1: 'bankCardImg', info2: '是', info3: 'String', info4: '银行卡正面照片' },
                        { info1: 'bankPhone', info2: '是', info3: 'String', info4: '银行卡预留手机号码' },
                        { info1: 'storeEntranceImg', info2: '是', info3: 'String', info4: '停车场门面照片' },
                        { info1: 'storeIndoorImg', info2: '是', info3: 'String', info4: '营业场所照片' },
                        ]
                },{
                    titleName: 'agreement',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'agreementOpenInvoiceType', info2: '是', info3: 'Integer', info4: '协议签订记录-开票方式0电子发票,1纸质发票,2停车场自行处理' },
                        { info1: 'agreementRepeatDeductionDealType', info2: '是', info3: 'Integer', info4: '协议签订记录-重复扣费处理方案0一点停优先处理,1停车场自行处理' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/ydtUser/getParkMerchantDetail.vue